// extracted by mini-css-extract-plugin
export default {"select":"Select-module__select--uGNPQ","portal":"Select-module__portal--tIRTZ","animatedBackground":"Select-module__animatedBackground--eu5_s"};